import React from "react";
import Test from "./test";

const info = {
  difficulty: "easy",
  title: "Invert Key Value of Object",
  url: "invert-key-value-object",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {object{}} obj
* @return {object{}}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function invert(obj) {
  // your code goes here        
};
`,
};

export default info;
